import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'commentDate'
})
export class CommentDatePipe implements PipeTransform {
  sameDay = 0;
  weekDays = 7;
  yearDays = 365;

  transform(value: string | Date): string {
    if (!value) {
      return '';
    }
    const todayStart = new Date();
    todayStart.setHours(0, 0, 0, 0);

    const todayEnd = new Date();
    todayEnd.setHours(23, 59, 59, 999);

    const date = new Date(value);
    const dateToCompare = new Date(value);
    dateToCompare.setHours(0, 0, 0, 0);

    const today = new Date();
    const daysDifference = Math.floor(Math.abs(today.getTime() - dateToCompare.getTime()) / (1000 * 60 * 60 * 24));

    if (daysDifference === this.sameDay) {
      return 'Today ' + this.formatTime(date);
    } else if (daysDifference < this.weekDays) {
      return this.dayOfWeek(date) + ' ' + this.formatTime(date);
    } else if (daysDifference < this.yearDays) {
      return this.formatDate(date);
    } else {
      return this.formatYearDate(date);
    }
  }

  private formatTime(date: Date): string {
    return date.toLocaleTimeString([], { hour: 'numeric', minute: 'numeric' });
  }

  private dayOfWeek(date: Date): string {
    return date.toLocaleString([], { weekday: 'long' });
  }

  private formatDate(date: Date): string {
    return date.toLocaleString('default', { day: 'numeric', month: 'long', hour: 'numeric', minute: 'numeric' });
  }

  private formatYearDate(date: Date): string {
    const options: Intl.DateTimeFormatOptions = {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    };

    return date.toLocaleString('default', options);
  }
}
